import { Spinner } from "react-bootstrap";
import "./turnAroundTimeStatistics.scss";
const TurnAroundTimeStatistics = ({ count = 0, isLoading, name = "" }: any) => {
  return (
    <div className="turnAroundTimeInfo">
      <header style={{ color: "#495057", fontSize: "32px" }}>
        {isLoading ? <Spinner animation="border" variant="text" /> : count}
        <span> hours</span>
      </header>
      <main style={{ color: "#495057" }}>{name}</main>
    </div>
  );
};

export default TurnAroundTimeStatistics;
